<template>
  <v-dialog v-model="value" width="1600" max-width="100%" scrollable persistent :fullscreen="$isMobile"
    :hide-overlay="$isMobile">
    <eod-card id="card_workflow_dialog" v-if="workflowInternal" :tile="$isMobile">
      <v-container fluid>
        <v-row>

          <v-col cols="12" md="12" lg="4">
            <v-row>
              <v-col cols="auto">
                <v-avatar size="52" color="primary"><v-icon dark>mdi-clipboard-outline</v-icon></v-avatar>
              </v-col>
              <v-col>
                <v-text-field class="mb-1" hide-details v-if="(workflowInternal.id && typeof workflowInternal.id != 'undefined')"
                  :value="workflowInternal.name" @input="setWorkflowName" dense></v-text-field>
                <div class="text-h7" v-if="(workflowInternal.id && typeof workflowInternal.id != 'undefined')">
                  {{ workflowInternal.taskType.name }}</div>
              </v-col>
            </v-row>

          </v-col>
          <v-col cols="12" md="12" lg="8" v-if="workflowInternal.id">
            <v-tabs v-model="workflowTab" right>
              <v-tabs-slider color="primary"></v-tabs-slider>
              <v-tab href="#form">
                <v-icon small left>mdi-play-outline</v-icon>
                Workflow
              </v-tab>
              <v-tab href="#company" v-if="workflowInternal.company">
                <v-icon small left>mdi-office-building-outline</v-icon>
                {{ workflowInternal.company.name }}
              </v-tab>
              <v-tab href="#project" v-if="workflowInternal.project">
                <v-icon small left>mdi-folder-open-outline</v-icon>
                {{ workflowInternal.project.name }}
              </v-tab>
              <v-tab href="#service" v-if="workflowInternal.service">
                <v-icon small left>mdi-file-sign</v-icon>
                {{ workflowInternal.service.name }}
              </v-tab>

            </v-tabs>
          </v-col>
        </v-row>
      </v-container>
      <v-divider class="elevation-2" style="z-index:5;"></v-divider>
      <v-card-text style="" class="pt-4">
        <v-tabs-items v-model="workflowTab">
          <v-tab-item value="form" transition="fade-transition">
            <eod-workflow :key="activeWorkflowStep" ref="addTaskModal" :default-planning="defaultPlanning"
              :value="workflowInternal" :activeStep="activeWorkflowStep" @stepChanged="val => { activeWorkflowStep = val }"
              :nameAppend="nameAppend" @saved="saved" @saving="(value, creatingWorkflows) => { saving = value; creatingChildWorkflows = creatingWorkflows || false; }" @loaded="workflowLoaded"
              @createWorkflow="(data, task, response) => $emit('createWorkflow', data, task, response)"
              :defaultProductId="defaultProductId" :defaultJobTypeId="defaultJobTypeId" :defaultTaskTypeConfigId="defaultTaskTypeConfigId"></eod-workflow>
          </v-tab-item>
          <v-tab-item v-if="workflowInternal.id && workflowInternal.project" value="project" transition="fade-transition">
            <eod-project-info :value="workflowInternal.project.id" :is-popup="false"></eod-project-info>
          </v-tab-item>
          <v-tab-item v-if="workflowInternal.id && workflowInternal.company" value="company" transition="fade-transition">
            <eod-company-info :value="workflowInternal.company.id" :is-popup="false"></eod-company-info>
          </v-tab-item>
          <v-tab-item v-if="workflowInternal.id && workflowInternal.service" value="service" transition="fade-transition">
            <eod-service-info :value="workflowInternal.service.id" :is-popup="false"></eod-service-info>
          </v-tab-item>
        </v-tabs-items>

      </v-card-text>
      <v-alert v-if="saving && creatingChildWorkflows" type="info" dense text class="mb-0 mx-3 mt-3">
        <v-progress-circular indeterminate size="16" width="2" class="mr-2"></v-progress-circular>
        Workflows worden aangemaakt... Dit kan even duren bij veel onderliggende assets.
      </v-alert>
      <v-card-actions class="grey lighten-3 py-3 px-3" v-if="value">
        <v-row>
          <v-col cols=12 sm=6 md="auto">
            <v-btn text @click="$emit('input', false)" rounded block>Annuleren</v-btn>
          </v-col>
          <v-col cols=12 sm=6 md="auto"
            v-if="!['done', 'cancelled'].includes(workflow.statusCode) && cell && cell.typeId == 'form' && shareUrl">
            <v-btn @click="shareDialogShown = true" rounded depressed><v-icon>mdi-share-variant</v-icon>Delen</v-btn>
            <eod-share-dialog v-if="shareDialogShown" v-model="shareDialogShown" :url="shareUrl"></eod-share-dialog>
          </v-col>
        </v-row>
        <v-spacer></v-spacer>
        <v-row style="flex-grow:0;" v-if="!['done', 'cancelled'].includes(workflow.statusCode)">
          <v-col cols=12 sm=6 md="auto" v-if="!hideSave">
            <v-btn id="btn_save_workflow" color="secondary" depressed rounded @click="save" block :disabled="saving"
              :loading="saving">
              <v-icon left>mdi-content-save</v-icon> Opslaan
            </v-btn>
          </v-col>
          <v-col cols=12 sm=6 md="auto"
            v-if="template?.content?.pages[activeWorkflowStep-1]?.showCancelWorkflowButton">
            <v-btn id="btn_cancel_workflow" color="error" depressed rounded @click="isCancelMotivationDialogVisible=true" block :disabled="saving"
              :loading="saving">
              <v-icon left>mdi-close-octagon-outline</v-icon> {{ template?.content?.pages[activeWorkflowStep-1]?.textCancelWorkflowButton || 'Workflow annuleren' }}
            </v-btn>
            <eod-dialog width="600" v-model="isCancelMotivationDialogVisible" title="Workflow annuleren" icon="mdi-close-octagon-outline" icon-color="error">
              <v-card-text>
                <div>Weet u zeker dat u deze workflow wilt annuleren?</div>
                <eod-textarea v-model="motivation" :label="'Reden van annulering'+(template?.content?.pages[activeWorkflowStep-1]?.requireCancelWorkflowMotivation ? '*' : '')"
                :rules="[val => template?.content?.pages[activeWorkflowStep-1]?.requireCancelWorkflowMotivation?$validator.required(val, 'Reden van annulering'):true]"
                  info="Geef een reden op voor de annulering van deze workflow."
                  class="mt-4" hide-ok></eod-textarea>
                  <v-alert type="error" dense text class="mt-2" v-if="isCancelMotivationErrorVisible">
                    Het ingeven van een motivatie is verplicht om de workflow te annuleren.
                  </v-alert>
              </v-card-text>
              <template v-slot:actions>
                <eod-btn @click="isCancelMotivationDialogVisible = false" text>Sluiten</eod-btn>
                <v-spacer></v-spacer>
                <eod-btn color="error" @click="cancel"><v-icon left>mdi-close-octagon-outline</v-icon>Workflow annuleren</eod-btn>
              </template>
            </eod-dialog>
          </v-col>
          <v-col cols=12 sm=6 md="auto"
            v-if="((cell && cell.typeId == 'fixed_form' && cell.settings.type == 'verify') || template?.content?.pages[activeWorkflowStep-1]?.showCancelFormButton)">
            <v-btn id="btn_reject_workflow" color="warning" depressed rounded @click="isRejectMotivationDialogVisible = true" block :disabled="saving"
              :loading="saving">
              <v-icon left>mdi-close-octagon-outline</v-icon> {{ template?.content?.pages[activeWorkflowStep-1]?.textCancelFormButton || 'Afwijzen' }}
            </v-btn>
            <eod-dialog width="600" v-model="isRejectMotivationDialogVisible" title="Workflow afwijzen" icon="mdi-close-octagon-outline" icon-color="warning">
              <v-card-text>
                <div>Weet u zeker dat u deze workflow wilt afwijzen?</div>
                <eod-textarea v-model="motivation" :label="'Reden van afwijzing'+(template?.content?.pages[activeWorkflowStep-1]?.requireCancelFormMotivation ? '*' : '')"
                :rules="[val => template?.content?.pages[activeWorkflowStep-1]?.requireCancelFormMotivation?$validator.required(val, 'Reden van afwijzing'):true]"
                  info="Geef een reden op voor de afwijzing van deze stap."
                  class="mt-4" hide-ok></eod-textarea>
                  <v-alert type="error" dense text class="mt-2" v-if="isRejectMotivationErrorVisible">
                    Het ingeven van een motivatie is verplicht om de workflow af te wijzen.
                  </v-alert>
              </v-card-text>
              <template v-slot:actions>
                <eod-btn @click="isRejectMotivationDialogVisible = false" text>Sluiten</eod-btn>
                <v-spacer></v-spacer>
                <eod-btn color="warning" @click="reject"><v-icon left>mdi-close-octagon-outline</v-icon>Afwijzen</eod-btn>
              </template>
            </eod-dialog>
          </v-col>
          
          <v-col cols=12 sm=6 md="auto" v-if="workflow">
            <v-btn id="btn_submit_workflow" color="success" depressed rounded @click="submit" block :disabled="saving"
              :loading="saving">
              <v-icon left>mdi-send</v-icon>
              
              <span v-if="template?.content?.pages[activeWorkflowStep-1]?.textNextStepButton">{{ template?.content?.pages[activeWorkflowStep-1]?.textNextStepButton }}</span>
              <span v-else-if="!(workflow && workflow.id) || (cell && cell.typeId == 'fixed_form' && cell.settings.type == 'info')">Starten</span>
              <span v-else-if="cell && cell.typeId == 'fixed_form' && cell.settings.type == 'verify'">Accepteren</span>
              <span v-else>Verzenden</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </eod-card>
  </v-dialog>
</template>
<script>
import eodProjectInfo from './eod-project-info';
import eodCompanyInfo from './eod-company-info';
import eodServiceInfo from './eod-service-info';
import eodProducts from './eod-products';
import eodProductTypes from './eod-productTypes';
import eodShareDialog from './eod-share-dialog';
import getEnv from '../classes/utils';

export default {
  components: {
    eodProjectInfo,
    eodCompanyInfo,
    eodServiceInfo,
    eodProducts,
    eodProductTypes,
    eodShareDialog
  },
  props: {
    value: Boolean,
    workflow: Object,
    nameAppend: String,
    hideSave: {
      type: Boolean,
      default: false
    },
    defaultPlanning: {
      type: Boolean,
      default: false
    },
    defaultProductId: {
      type: String | Object,
    },
    defaultTaskTypeConfigId: {
      type: String | Object,
    },
    defaultJobTypeId: {
      type: String | Object,
    }
  },
  data() {
    return {
      workflowTab: 'form',
      workflowInternal: null,
      motivation: null,
      isCancelMotivationDialogVisible: false,
      isRejectMotivationDialogVisible: false,
      isRejectMotivationErrorVisible: false,
      isCancelMotivationErrorVisible: false,
      activeWorkflowStep: null,
      saving: false,
      creatingChildWorkflows: false,
      cell: null,
      template: null,
      shareDialogShown: false,
      shareUrl: 'https://' + this.$eod.getRealm() + '.' + getEnv('VUE_APP_MOBILE_URL') + '/form/' + (this.workflow ? this.workflow.id : null)
    }
  },
  created(){
    this.workflowInternal = this.workflow;
  },
  methods: {
    setWorkflowName(name) {
      if (this.$refs.addTaskModal) {
        this.$refs.addTaskModal.setWorkflowName(name);
      }
    },
    workflowLoaded(cell, template) {
      this.template = template;
      this.cell = cell;
    },
    save() {
      if (this.$refs.addTaskModal) {
        this.$refs.addTaskModal.save();
      }
    },
    submit() {
      if (this.$refs.addTaskModal) {
        if (this.$refs.addTaskModal.validate(true)) {
          this.$refs.addTaskModal.submit();
        } else {
          this.$toaster.notify({
            type: 'danger',
            title: 'Fout',
            body: 'Formulier bevat nog fouten!'
          });
        }
      }
    },
    reject() {
      this.isRejectMotivationErrorVisible = false;
      if(this.template?.content?.pages[this.activeWorkflowStep-1]?.requireCancelFormMotivation && (!this.motivation || this.motivation.trim() === '')){
        this.isRejectMotivationErrorVisible = true;
        return;
      }

      if (this.$refs.addTaskModal) {
        this.$refs.addTaskModal.reject(this.motivation);
      }

      this.isRejectMotivationDialogVisible = false;
      this.motivation = null;
    },
    cancel() {
      this.isCancelMotivationErrorVisible = false;
      if(this.template?.content?.pages[this.activeWorkflowStep-1]?.requireCancelWorkflowMotivation && (!this.motivation || this.motivation.trim() === '')){
        this.isCancelMotivationErrorVisible = true;
        return;
      }

      if (this.$refs.addTaskModal) {
        this.$refs.addTaskModal.cancel(this.motivation);
      }

      this.isCancelMotivationDialogVisible = false;
      this.motivation = null;
    },
    async saved(task, job) {
      this.saving = false;

      // If next step and next step has same team as current user, keep dialog open
      // Get active step of workflow
      const workflowTemplate = task.templates?.filter(template => template.type == 'WORKFLOW')[0];
      if(workflowTemplate){
        let lastJobId = null;
        for (let pageIndex = 0; pageIndex < workflowTemplate.content.pages.length; pageIndex++) {
          const page = workflowTemplate.content.pages[pageIndex];
          for (let cellIndex = 0; cellIndex < page.cells.length; cellIndex++) {
            const cell = page.cells[cellIndex];
            if(cell.jobId){
              lastJobId = cell.jobId;
            }
          }
        }

        // If last job is not current job, check if user is in next team
        if(job && lastJobId != job.id){
          // Get workfow from backend to check active step
          const workflow = await this.$eod.getById('task', task.id, ['id', 'name', 'project{id name}','company{id name}', 'taskType{id name}', 'service{id name}','stepId']).then(response => {
            return response?.data?.data?.task;
          });

          // Next step, check if same team as current user
          for (let pageIndex = 0; pageIndex < workflowTemplate.content.pages.length; pageIndex++) {
            const page = workflowTemplate.content.pages[pageIndex];
            if(page.id == workflow.stepId){
              const cell = page.cells[0];
              if(cell && cell.settings?.responsibleTeam && this.$eod.getUser().groups.map(g => g.id).includes(cell.settings?.responsibleTeam)){
                // Same team, keep dialog open
                this.workflowInternal = workflow;
                this.activeWorkflowStep = pageIndex + 1;
                return;
              }

              break;
            }
          }
        }
      }
      
      this.$emit('saved', task, job);
    }
  }
}
</script>